import { render } from "./DepositLimitBar.vue?vue&type=template&id=0f0f443f&scoped=true"
import script from "./DepositLimitBar.vue?vue&type=script&lang=js"
export * from "./DepositLimitBar.vue?vue&type=script&lang=js"

import "./DepositLimitBar.vue?vue&type=style&index=0&id=0f0f443f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f0f443f"]])

export default __exports__